module.exports = __webpack_public_path__ + "static/img/logWarning.1a4b406.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logWarning.png
// module id = Ng0g
// module chunks = 1